import Api from "./Api";
import store from "../state/store";

export default {
  addAnnouncement(payload){
    return Api().post(`/announcement`, payload);
  },
  getAnnouncements(){
    return Api().get(`/announcements/${store.getters["authfack/currentEntity"].id}`);
  },
  getAnnouncement(id){
    return Api().get(`/announcement/${id}`);
  },
  editAnnouncement(payload) {
    return Api().put(`/announcement/${payload.id}`, payload.data);
  },
  deleteAnnouncement(id){
    return Api().delete(`/announcement/${id}`);
  },
};
